<template>
  <b-navbar toggleable="md" type="dark" variant="dark" fixed="top">
    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
    <b-navbar-brand href="#" class="d-md-none logo-wrapper">
      <div class="logo mobile">
        <hero :hero-props="{ height: 25 }"></hero>
      </div>
    </b-navbar-brand>

    <b-collapse is-nav id="nav_collapse">
      <scrollactive :offset="0" @itemchanged="itemChanged" class="w-100">
        <ul class="navbar-nav">
          <li class="d-none d-md-block w-100"></li>
          <li class="nav-item">
            <router-link class="nav-link scrollactive-item text-uppercase font-weight-bold" :to="navHref(0)">{{ navLabel(0) }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link scrollactive-item text-uppercase font-weight-bold" :to="navHref(1)">{{ navLabel(1) }}</router-link>
          </li>
          <li class="navbar-brand d-none d-md-block">
            <router-link to="/">
              <hero class="align-text-middle" :hero-props="{ height: 25, width: 200 }"></hero>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link scrollactive-item text-uppercase font-weight-bold" :to="navHref(2)">{{ navLabel(2) }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link scrollactive-item text-uppercase font-weight-bold" :to="navHref(3)">{{ navLabel(3) }}</router-link>
          </li>
          <li class="d-none d-md-block w-100"></li>
        </ul>
      </scrollactive>
    </b-collapse>
  </b-navbar>
</template>

<script>
import Hero from '@/components/Hero.vue'

export default {
  name: 'navigation',
  components: {
    Hero
  },
  props: ['navProps'],
  methods: {
    navHref: function (idx) {
      return "/#" + this.navProps.items[idx].id
    },
    navLabel: function (idx) {
      return this.navProps.items[idx].name
    },
    itemChanged: function (evt, current, last) {
      if (current) {
        current.parentElement.classList.add('active')
      }
      if (last) {
        last.parentElement.classList.remove('active')
      }
      const uri = evt.path[0].baseURI.replace(/#[\da-zA-Z-_]*$/, '').replace(/\/$/,'')
      if (uri != evt.path[0].origin) {
        // When the page is not main page, remove active class
        if (current) {
          current.parentElement.classList.remove('active')
        }
        if (last) {
          last.parentElement.classList.remove('active')
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.logo-wrapper {
  position: relative;
}

.logo {
  &.mobile {
    position: fixed;
    top: 16px;
    left: 100px;
    right: 100px;
    margin: 0 auto;
    z-index: 3000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue